<script lang="ts" setup>
import {  useClipboard  } from "#imports";

const props = defineProps<{
    source?: string;
    keyword?: string;
}>();

const sourceRef = computed(() => props.source ?? "");

const { copy, copied, text, isSupported } = useClipboard({
    source: sourceRef,
    legacy: true,
});
</script>

<template>
    <slot
        :copy="copy"
        :copied="copied"
        :is-supported="isSupported"
        :text="text"
    />
</template>
